import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} SavedItem
 */
export default PropTypes.shape({
  id: PropTypes.number,
  title: PropTypes.string,
  slug: PropTypes.string,
  timecodeIn: PropTypes.string,
  timecodeDur: PropTypes.string,
  channel: PropTypes.string,
  layer: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/savedItem.js